import { render, staticRenderFns } from "./empty_whishlist.vue?vue&type=template&id=457e9035&scoped=true"
import script from "./empty_whishlist.vue?vue&type=script&lang=js"
export * from "./empty_whishlist.vue?vue&type=script&lang=js"
import style0 from "./empty_whishlist.vue?vue&type=style&index=0&id=457e9035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e9035",
  null
  
)

export default component.exports